import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OrderStatus, SubscriptionOrderStatus} from '../../../core/models/order.model';
import {Customer} from '../../../core/models/customer.model';
import * as moment from 'moment';
import {FormatDataService} from '../../../core/services/format-data.service';
import { ActivatedRoute } from '@angular/router';
import { RestaurantStore } from '../../../core/stores/restaurant.store';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-order-status',
  templateUrl: './order-status.component.html',
  styleUrls: ['./order-status.component.scss']
})
export class OrderStatusComponent implements OnInit {
  @Input()
  public orderStatus: OrderStatus;
  @Input()
  public subscriptionOrderStatus: SubscriptionOrderStatus;
  @Input()
  public customer: Customer;
  @Input()
  public estimatedTimeInMinutes: number;
  @Input()
  public hideETA: boolean;
  @Input()
  public isGroup: boolean;
  @Input()
  public isSubscription: boolean;
  @Input()
  public isSubscriptionHistory: boolean;
  @Input()
  public currencySign = '$';

  @Output() cancelSubscriptionEmitter = new EventEmitter<string>();

  serviceChargeName = null;

  public get subscriptionTitle(): string {
    if (this.isCadenceEqualsValue('daily')) {
      return `Every day`;
    } else if (this.isCadenceEqualsValue('weekly')) {
      return `Every ${this.subscriptionDays}`;
    } else if (this.isCadenceEqualsValue('monthly')) {
      return `${this.subscriptionPeriods} ${this.subscriptionDays} of each month`;
    }
  }

  public get subscriptionDays(): string {
    if (this.isCadenceEqualsValue('daily')) {
      return '';
    }
    return `${this.formatDataService.buildCommaListWithAnd(this.subscriptionOrderStatus.dayTypes)}`;
  }

  public get subscriptionPeriods(): string {
    if (!this.isCadenceEqualsValue('monthly')) {
      return '';
    }
    return this.subscriptionOrderStatus.periods;
  }

  public get orderNumber(): string {
    if (this.isGroup) {
      return `Orders #${this.orderStatus.orderId} (#${this.orderStatus.number})`;
    }
    return `Order #${this.orderStatus.number}`;
  }

  public get orderDate(): string {
    if (this.orderStatus.isAsap || !this.orderStatus.pickupAt) {
      return ``;
    }
    const formattedDate = moment(this.orderStatus.pickupAt).format('dddd, MMMM Do, YYYY');
    if (this.isSubscriptionHistory) {
      return ` • ${formattedDate}`;
    }
    return ` • Scheduled for ${formattedDate}`;
  }

  public get belongToCustomer(): boolean {
    if (!this.customer) {
      return;
    }
    return this.customer.squareCustomerId === this.orderStatus.customerId;
  }

  public get isInProgressCustomerOrder(): boolean {
    return this.belongToCustomer && this.orderStatus.formattedStatus === 'NEW';
  }

  public get orderStatusModification(): string {
    if (this.orderStatus.hasPastStatus || this.isSubscriptionHistory) {
      return 'order-card--grey';
    }
    return this.belongToCustomer ? 'order-card--brand' : 'order-card--dark';
  }

  constructor(private formatDataService: FormatDataService, private route: ActivatedRoute, private restaurantStore: RestaurantStore) { }

  ngOnInit() {
    this.route.params.subscribe((data) => {
      this.restaurantStore.getRestaurantById(data.locationId).pipe(take(1)).subscribe((restaurant) => {
        this.serviceChargeName = restaurant?.serviceChargeName;
      });
    });
  }

  public cancelSubscription(subscriptionId: string): void {
    this.cancelSubscriptionEmitter.emit(subscriptionId);
  }

  public isCadenceEqualsValue(value: string): boolean {
    return this.subscriptionOrderStatus?.cadence.toLowerCase() === value;
  }
}
